import styled from 'styled-components';

/**
 * This component mirrors the minimal styles of the atlaskit/button required in the use case.
 * Standard atlaskit/button has problems with blur events, because of that 'ctrl+v' focus/blur was bugged.
 */
export const UploadAttButtonStyled = styled.button`
  margin: 0;
  padding: 0;
  width: 32px;
  height: 32px;

  display: flex;
  align-items: center;
  justify-content: center;

  flex: 0 0 32px;

  border: none;
  border-radius: 3px;

  outline: none;

  cursor: pointer;

  color: var(--ds-text, var(--ds-fb-text));
  background: var(--ds-background-neutral, var(--ds-fb-background-neutral));

  :hover {
    background: var(
      --ds-background-neutral-hovered,
      var(--ds-fb-background-neutral-hovered)
    );
  }

  :active {
    background: var(
      --ds-background-neutral-pressed,
      var(--ds-fb-background-neutral-pressed)
    );
  }
`;
